import { render } from "./MdInputChip.vue?vue&type=template&id=4db2e0b9&scoped=true&ts=true"
import script from "./MdInputChip.vue?vue&type=script&lang=ts"
export * from "./MdInputChip.vue?vue&type=script&lang=ts"

import "./MdInputChip.vue?vue&type=style&index=0&id=4db2e0b9&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db2e0b9"]])

export default __exports__